// axiosInstance.js
import axios from 'axios';
import store from './store';
import { logoutUser } from './redux/userSlice';
import { API_URL_All } from './api';
import { useNavigate } from 'react-router-dom';

const pendingRequests = new Map();
const getRequestKey = (config) => {
  return `${config.method}-${config.url}`;
};

const axiosInstance = axios.create({
  baseURL: API_URL_All,
  //headers: {
  //  'Content-Type': 'application/json',
  //},
});
function isTokenValid(token) {
  if (!token) return false;
  if (token.startsWith('000')) token = token.slice(3);

  try {
    const payloadBase64 = token.split('.')[1];
    //const decodedPayload = JSON.parse(atob(payloadBase64));
    const decodedPayload = decodePayload(payloadBase64);
    const exp = decodedPayload.exp;

    const expDate = new Date(exp * 1000);

    const now = Math.floor(Date.now() / 1000);
    var result = exp > now;

    return result;
  } catch (err) {
    console.error('Token is invalid', err);
    return false;
  }
}
function decodePayload(payloadBase64) {
  let base64 = payloadBase64.replace(/-/g, '+').replace(/_/g, '/');

  while (base64.length % 4 !== 0) {
    base64 += '=';
  }

  const jsonStr = atob(base64);
  return JSON.parse(jsonStr);
}

axiosInstance.interceptors.request.use(
  (config) => {
    var token = localStorage.getItem('token');
    if (!token || !isTokenValid(token)) {
      store.dispatch(logoutUser());
      useNavigate('/dang-nhap');
      return Promise.reject(new Error('Token is invalid'));
    }

    config.headers.Authorization = `Bearer ${token}`;

    const requestKey = getRequestKey(config);
    if (pendingRequests.has(requestKey)) {
      return Promise.reject(new axios.Cancel(`Duplicate request to ${config.url} canceled.`));
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => {
    const requestKey = getRequestKey(response.config);
    pendingRequests.delete(requestKey);
    return response;
  },
  (error) => {
    const requestKey = getRequestKey(error.config || {});
    pendingRequests.delete(requestKey);

    if (error.response?.status === 401) {
      const headers = error.config?.headers;
      const raw = headers?.Authorization || headers?.authorization || "";
      const failedToken = String(raw).replace(/^Bearer\s+/i, "");
      const currentToken = localStorage.getItem("token");
      if (!currentToken || failedToken === currentToken) {
        store.dispatch(logoutUser());
        useNavigate('/dang-nhap');
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
